import React, { useEffect, useState } from 'react'
import { Card, Grid, makeStyles, Typography, Container, Button, MenuItem } from '@material-ui/core'
import LoadingBeforeViewData from '../compartidos/LoadingBeforeViewData';
import { useHistory, useParams } from 'react-router';
import AfiliadoService from '../../services/AfiliadoService'
import { startAlerta } from '../../actions/ui/alertas';
import { useDispatch } from 'react-redux';
import { SelectValidator, TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import AvisoPrestacionService from '../../services/AvisoPrestacionService';
import { handleErrorApi } from '../../helpers/randoms';
import { finishSpinner, startSpinner } from '../../actions/ui/spinner';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        marginTop: "1.5rem",
        marginBottom: "1rem"
    },
    container: {
        marginLeft: "auto",
        marginRight: "auto",
        padding: "1rem",
        display: "block",
        borderRadius: 15
    },
    img: {
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: "1rem",
        width: "50%"
    },
    title: {
        marginRight: "auto",
        marginLeft: "auto",
        marginTop: "0.75rem",
        fontSize: "0.70rem",
        display: "block"
    }
}));

const InformacionAfiliado = () => {
    const classes = useStyles()
    const history = useHistory()
    const dispatch = useDispatch()

    const [data, setdata] = useState(null)
    const [cuit, setCuit] = useState("")
    const [idTipoConsulta, setIdTipoConsulta] = useState("")

    const { idAfiliado } = useParams();

    const getDataAfiliado = async () => {
        try {
            const result = await AfiliadoService.getData(idAfiliado)
            const body = await result.json()
            if (result.ok) {
                setdata(body)
            } else {
                throw body.errores
            }
        } catch (error) {
            console.log("Hubo un error al traer la información del usuario")
            history.push("/auth/login")
            if (error.mensaje) {
                dispatch(startAlerta(error.mensaje, "error"))
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        dispatch(startSpinner())

        try {
            
            const dataForm={
                cuitPrestador: cuit,
                idTipoConsulta: idTipoConsulta,
                idAfiliado: idAfiliado
            }
            const result = await AvisoPrestacionService.validarDatosParaTurno(dataForm)
            const body = await result.json()
            if (result.ok) {
                history.push(`/afiliado/prestador/enviar-notificacion-afiliado/${body.idRegistroAtencion}`)
                dispatch(finishSpinner())
            } else {
                throw body
            }
        } catch (error) {
            dispatch(finishSpinner())
            handleErrorApi(dispatch, error, "Error al validar prestador", "Ha ocurrido un error")
        }
    }

    useEffect(() => {
        getDataAfiliado()
        // eslint-disable-next-line
    }, [])

    if (data === null) {
        return <LoadingBeforeViewData />
    }

    return (
        <div className={classes.root}>
                <Container maxWidth="md">
                    <Grid container >
                        <Grid item xs={12} md={6} className={classes.container} elevation={6} component={Card} variant="outlined">
                            <Typography variant="h5" align="center">Información del beneficiario/a</Typography>
                            <Typography variant="overline" align="center" className={classes.title}>Nombre y Apellido</Typography>
                            <Typography align="center" style={{ fontWeight: "bold" }}>{data.apellidoYNombre}</Typography>

                            <Typography variant="overline" align="center" className={classes.title}>DNI</Typography>
                            <Typography align="center" style={{ fontWeight: "bold" }}>{data.nroDocumento}</Typography>

                            <Typography variant="overline" align="center" className={classes.title}>Número de afiliado</Typography>
                            <Typography align="center" style={{ fontWeight: "bold" }}>{data.numero}</Typography>

                            {
                                !data.vigente ?
                                    <Typography variant="overline" align="center" className={classes.title} style={{ color: "#ff0000", fontSize: "1rem", fontWeight: "bold" }}>COBERTURA INACTIVA</Typography>
                                    :
                                    <Typography variant="overline" align="center" className={classes.title} style={{ color: "#2f9f66", fontSize: "1rem", fontWeight: "bold" }}>COBERTURA ACTIVA</Typography>
                            }
                        </Grid>
                    </Grid>
                    {
                        data.vigente &&
                        <Grid container style={{ marginTop: "1rem" }}>
                            <Grid item xs={12} md={6} className={classes.container} elevation={6} component={Card} variant="outlined">
                                <ValidatorForm onSubmit={handleSubmit}>
                                    <Typography variant="h5" align="center">Aviso de Prestación</Typography>
                                    <Typography variant="overline" align="center" className={classes.title}>CUIT DEL PRESTADOR</Typography>
                                    <TextValidator
                                        margin="normal"
                                        fullWidth
                                        value={cuit}
                                        onChange={(e) => setCuit(e.target.value)}
                                        validators={['required', 'matchRegexp:^[0-9]{11}$']}
                                        errorMessages={['El CUIT es requerido', 'El CUIT debe tener 11 dígitos']}
                                        variant="outlined"
                                    />
                                        <Typography variant="overline" align="center" className={classes.title}>Tipo de consulta</Typography>

                                    <SelectValidator
                                        margin="normal"
                                        fullWidth
                                        value={idTipoConsulta}
                                        onChange={(e) => setIdTipoConsulta(e.target.value)}
                                        validators={['required']}
                                        errorMessages={['El tipo de consulta es requerido']}
                                        variant="outlined"
                                    >
                                        <MenuItem value={1}>Consulta médica</MenuItem>
                                        <MenuItem value={2}>Consulta con especialista</MenuItem>
                                        <MenuItem value={0}>Consulta en guardia</MenuItem>
                                    </SelectValidator>
                                    <div style={{ textAlign: "center" }}>
                                        <Button variant="contained" color="primary" style={{ marginTop: "1rem" }} type="submit"> Consultar</Button>
                                    </div>
                                </ValidatorForm>
                            </Grid>
                        </Grid>
                    }
                </Container>
        </div>
    )
}

export default InformacionAfiliado
